"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function createFacebookShareLink(baseUrl, route, title) {
  var shareUrl = "" + baseUrl + route + "%3Fsource%3Dfbshare";
  return "https://www.facebook.com/sharer/sharer.php?u=" + shareUrl;
}

exports.createFacebookShareLink = createFacebookShareLink;

function createTwitterShareLink(baseUrl, route, title) {
  var shareUrl = "" + baseUrl + route + "?source=tshare";
  return "https://twitter.com/intent/tweet?text=" + encodeURIComponent(title) + "&url=" + encodeURIComponent(shareUrl);
}

exports.createTwitterShareLink = createTwitterShareLink;

function createEmailShareLink(baseUrl, route, title) {
  var shareUrl = "" + baseUrl + route + "%3Fsource%3Demail";
  return "mailto:info@example.com?&subject=&body=" + shareUrl;
}

exports.createEmailShareLink = createEmailShareLink;